import { Box, Flex, styled } from '@project44/manifest-ds';

export const PREDICTED_BG_COLOR = '$palette-indigo-50';
export const STALE_BG_COLOR = '$palette-grey-100';

export const Label = styled('div', {
  color: '$palette-grey-500',
  fontSize: '$x-small',
  lineHeight: '14px',
  fontWeight: '$semibold',
  marginBottom: '$small',
});

export const DiffDays = styled('span', {
  fontSize: 10,
  marginLeft: '-4px', // offsets `gap: 4px`
  position: 'relative',
  top: '-2px', // superscript
  verticalAlign: 'text-bottom',
});

export const Timezone = styled('span', {
  variants: {
    addPadding: {
      true: {
        paddingRight: 8,
      },
      false: {
        paddingRight: 0,
      },
    },
  },
});

export const StackedFormatWrapper = styled(Flex, {
  padding: '4px 8px 4px 0px',
  variants: {
    isPrediction: {
      true: {
        backgroundColor: PREDICTED_BG_COLOR,
        borderRadius: '$small',
        padding: '4px 8px 4px 4px', // padding left to add space before icon
      },
    },
    isStale: {
      true: {
        backgroundColor: STALE_BG_COLOR,
      },
    },
    hasNoData: {
      true: {
        padding: 0,
      },
    },
  },
});

export const PredictedBox = styled(Box, {
  backgroundColor: PREDICTED_BG_COLOR,
  borderRadius: '$small',
  padding: '2px 8px',
  position: 'relative',
  width: 'fit-content',
});

export const DateComponentWrapper = styled(Box, {
  alignItems: 'center',
  display: 'flex',
  width: 'fit-content',
  variants: {
    isStacked: {
      true: {
        alignItems: 'flex-start',
      },
    },
  },
});

export const DateTimeWrapper = styled(Box, {
  alignItems: 'center',
  borderRadius: '$small',
  display: 'flex',
  gap: '4px',
  padding: '2px 4px 2px 2px',
  '.middot': {
    color: '$text-tertiary',
  },
});
